<template>
    <div :data-student-progress="progress">
        <div v-if="nocard">
            <div v-if="progress !== null" class="row">
                <div class="cssProgress" :class="lessonId ? 'col-10' : 'col-11'">
                    <div class="progress1">
                        <transition appear @before-appear="beforeAppear" @appear="onAppear">
                            <div
                                class="cssProgress-bar cssProgress-active"
                                :class="type"
                                :data-percent="progress"
                                :style="{ width: progress + '%' }"
                            ></div>
                        </transition>
                    </div>
                </div>
                <div
                    class="d-flex justify-content-center"
                    :class="lessonId ? 'col-2 px-1' : 'col-1'"
                >
                    <p style="font-weight: bold">{{ progress }}%</p>
                </div>
            </div>
            <div v-else class="d-flex justify-content-center">
                <loading-spinner mini :color="color"></loading-spinner>
            </div>
            <slot></slot>
        </div>
        <card
            v-else
            :class="[moduleId ? 'card-shadow' : '', noShadow ? 'nch-no-shadow' : '', lessonId ? 'mb-0' : '' ]"
            :body-classes="progress !== null ? 'pb-1' : 'py-2'"
            :style="{backgroundColor: moduleId ? '#F7FAFC' : ''}"
        >
            <div v-if="progress !== null" class="row">
                <div class="cssProgress" :class="lessonId ? 'col-10' : 'col-11'">
                    <div class="progress1">
                        <transition appear @before-appear="beforeAppear" @appear="onAppear">
                            <div
                                class="cssProgress-bar cssProgress-success cssProgress-active"
                                :data-percent="progress"
                                :style="{ width: progress + '%' }"
                            ></div>
                        </transition>
                    </div>
                </div>
                <div
                    class="d-flex justify-content-center"
                    :class="lessonId ? 'col-2 px-1' : 'col-1'"
                >
                    <p style="font-weight: bold">{{ progress }}%</p>
                </div>
            </div>
            <div v-else class="d-flex justify-content-center">
                <loading-spinner mini :color="color"></loading-spinner>
            </div>
            <slot></slot>
        </card>
    </div>
</template>

<script>
import LoadingSpinner from '../Common/LoadingSpinner';

import Card from '../../argon/components/Cards/Card';

export default {
    name: 'ProgressBar',
    components: {
        Card,
        LoadingSpinner,
    },
    props: {
        planId: {
            type: Number,
        },
        courseId: {
            type: Number,
        },
        moduleId: {
            type: Number,
        },
        lessonId: {
            type: Number,
        },
        exerciseId: {
            type: Number,
        },
        noShadow: {
            type: Boolean,
        },
        nocard: Boolean,
        type: String,
    },
    data() {
        return {
            width: 0,
            baseUrl: '/api/app/progress',
            localProgress: null,
        };
    },
    computed: {
        progress: {
            get() {
                if (this.lessonId || this.exerciseId) {
                    return this.$store.getters.LOADED_PROGRESS;
                }

                return this.localProgress;
            },
        },
        color() {
            return this.$store.getters.COLOR;
        },
        url() {
            const url = `${this.baseUrl}/plan/${this.planId}`;

            if (this.lessonId) {
                return `${this.baseUrl}/lesson/${this.lessonId}`;
            } else if (this.moduleId) {
                return `${url}/course/${this.courseId}/module/${this.moduleId}`;
            } else if (this.courseId) {
                return `${url}/course/${this.courseId}`;
            } else if (this.exerciseId) {
                return `${this.baseUrl}/exercise/${this.exerciseId}`;
            }

            return url;
        },
    },
    watch: {
        planId(val) {
            if (val) return this.getProgress();
        },
        lessonId(val) {
            if (val) return this.getProgress();
        },
    },
    methods: {
        // Animação da barra de progresso
        beforeAppear(el) {
            el.style.width = 0;
        },
        // Animação da barra de progresso
        onAppear(el, done) {
            const interval = setInterval(() => {
                if (this.width === this.progress) {
                    clearInterval(interval);
                    return done();
                }

                el.style.width = `${this.width}%`;
                this.width++;
            }, 10);
        },
        async getProgress() {
            await this.$store.commit('SET_PROGRESS_URL', this.url);
            this.localProgress = await this.$store.dispatch(
                'GET_CONTENT_PROGRESS',
            );
        },
    },
    mounted() {
        if (this.planId || this.lessonId || this.exerciseId) {
            this.getProgress();
        }
    },
};
</script>

<style scoped>
.nch-no-shadow {
    box-shadow: unset;
}
</style>
